import React from "react";

const PricingTier = ({ title, price, features, isPopular, buttonText }) => {
  return (
    <div
      className={`bg-white rounded-lg shadow-lg p-6 flex flex-col ${
        isPopular ? "border-2 border-blue-500 md:transform md:scale-105" : ""
      }`}
    >
      {isPopular && (
        <span className="bg-blue-500 text-white px-4 py-1 rounded-full text-sm font-bold self-start mb-4">
          Most Popular
        </span>
      )}
      <h3 className="text-xl font-bold mb-2">{title}</h3>
      <div className="mb-4">
        <span className="text-3xl font-bold">{price}</span>
        {price !== "Contact Us!" && (
          <span className="text-gray-600">/month</span>
        )}
      </div>
      <ul className="mb-6 flex-grow">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start mb-2">
            <svg
              className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <button
        className={`py-2 px-4 rounded font-bold ${
          isPopular
            ? "bg-blue-500 hover:bg-blue-600 text-white"
            : "bg-gray-200 hover:bg-gray-300 text-gray-800"
        }`}
      >
        {buttonText || "Get Started"}
      </button>
    </div>
  );
};

const Pricing = () => {
  const pricingTiers = [
    {
      title: "Standard",
      price: "$10",
      features: [
        "Basic authentication",
        "User profile management",
        "Email notifications",
        "Basic support",
        "1GB storage",
      ],
      isPopular: false,
      buttonText: "Start Standard",
    },
    {
      title: "Advanced",
      price: "$25",
      features: [
        "Everything in Standard",
        "Advanced authentication",
        "Priority support",
        "Custom branding",
        "10GB storage",
        "Analytics dashboard",
      ],
      isPopular: true,
      buttonText: "Start Advanced",
    },
    {
      title: "Enterprise",
      price: "Contact Us!",
      features: [
        "Everything in Advanced",
        "Dedicated support",
        "Custom integrations",
        "Unlimited storage",
        "SLA guarantees",
        "On-premise options",
        "Advanced security features",
      ],
      isPopular: false,
      buttonText: "Contact Sales",
    },
  ];

  return (
    <div className="container mx-auto px-4 py-8 md:py-12">
      <div className="text-center mb-8 md:mb-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">Choose Your Plan</h1>
        <p className="text-lg md:text-xl text-gray-600">
          Select the perfect plan for your needs
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
        {pricingTiers.map((tier, index) => (
          <PricingTier key={index} {...tier} />
        ))}
      </div>

      <div className="text-center mt-8 md:mt-12">
        <p className="text-gray-600">
          All plans include a 14-day free trial. No credit card required.
        </p>
        <p className="mt-2">
          <a
            href="mailto:info@team-skynet.io"
            className="text-blue-500 hover:underline"
          >
            Questions? Contact our sales team
          </a>
        </p>
      </div>
    </div>
  );
};

export default Pricing;
